import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { useEffect, useRef, useState } from 'react';

import type { SidebarMenuItemModel } from '../../types';
import { MenuItem } from '../MenuItem/MenuItem';

import * as Styled from './styles';

interface Props {
  list: SidebarMenuItemModel[];
  activeKey?: string;
  activeChildKey?: string;
}

export const SidebarMenu = ({ list, activeKey, activeChildKey }: Props) => {
  const { token } = theme.useToken();
  const [active, setActive] = useState<string | null>(null);
  const [activeChild, setActiveChild] = useState<string | null>(
    activeChildKey ?? null
  );
  const [isMenuCollapsed, setIsMenuCollapsed] = useState<boolean>(true);
  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node) &&
        !isMenuCollapsed
      ) {
        setIsMenuCollapsed(true);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuCollapsed]);

  useEffect(() => {
    const keyParts = activeKey?.split('/');
    const splittedActiveKey: string =
      keyParts?.[keyParts.length - 1] ?? list[0].key;

    setActive(splittedActiveKey);
  }, [activeKey, list]);

  useEffect(() => {
    setActiveChild(activeChildKey ?? null);
  }, [activeChildKey]);

  return (
    <Styled.Sidebar
      ref={sidebarRef}
      $backgroundColor={token.Layout?.siderBg}
      $isMenuCollapsed={isMenuCollapsed}>
      <Styled.SidebarMenu>
        {list.map(item => (
          <MenuItem
            key={item.key}
            item={item}
            active={active}
            setActive={setActive}
            activeChild={activeChild}
            setActiveChild={setActiveChild}
            isMenuCollapsed={isMenuCollapsed}
            setIsMenuCollapsed={setIsMenuCollapsed}
          />
        ))}
      </Styled.SidebarMenu>
      <Styled.SidebarMenuFooter>
        <button
          type='button'
          onClick={() => setIsMenuCollapsed(state => !state)}
          aria-label='Collapse Menu Button'>
          {isMenuCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </button>
      </Styled.SidebarMenuFooter>
    </Styled.Sidebar>
  );
};
